"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportChannel = void 0;
const action_1 = require("../../action");
const topic_1 = require("../../topic");
const SPORT_CHANNEL = "sport";
class SportChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = SPORT_CHANNEL;
        this.topics = {
            betsUpdate: new topic_1.Topic('betsUpdate', SPORT_CHANNEL, this._logger),
            preOpenMyBets: new topic_1.Topic('preOpenMyBets', SPORT_CHANNEL, this._logger),
            openMyBets: new topic_1.Topic('openMyBets', SPORT_CHANNEL, this._logger),
            betslipVisibilityChange: new topic_1.Topic('betslipVisibilityChange', SPORT_CHANNEL, this._logger),
            toggleBetslip: new action_1.Action('toggleBetslip', SPORT_CHANNEL, this._logger),
        };
    }
}
exports.SportChannel = SportChannel;
//# sourceMappingURL=sport.channel.js.map